import { HORIZONTE_MAX, HORIZONTE_MIN } from "../../lib/projecao/tipos";

/*
 * Saneamento puro do horizonte da projeção (FE-2 CP-C).
 *
 * Núcleo testável por unidade, separado do componente `ControleHorizonte` (a
 * regra react-refresh proíbe exportar não-componentes de um arquivo de
 * componente). O JSX só encaminha o resultado destas funções.
 */

/**
 * Restringe `n` à faixa fechada [minimo, maximo]. A faixa é parametrizável (o
 * Dashboard usa teto 120 — limite do backend do dashboard); os defaults são as
 * constantes da projeção (1..365), preservando o comportamento original.
 */
export function clampHorizonte(
  n: number,
  minimo: number = HORIZONTE_MIN,
  maximo: number = HORIZONTE_MAX,
): number {
  if (n < minimo) {
    return minimo;
  }
  if (n > maximo) {
    return maximo;
  }
  return n;
}

/**
 * Saneia o texto bruto do input num horizonte VÁLIDO, ou `null` quando não há
 * nada a emitir (vazio ou não-parseável). `<input type=number>` já filtra parte
 * do lixo, mas a função se defende independentemente da borda do DOM — nunca
 * propaga um horizonte fora de [minimo, maximo]. A faixa é parametrizável (ver
 * `clampHorizonte`); os defaults são 1..365 (projeção).
 */
export function sanearHorizonte(
  bruto: string,
  minimo: number = HORIZONTE_MIN,
  maximo: number = HORIZONTE_MAX,
): number | null {
  if (bruto.trim() === "") {
    return null;
  }
  const parseado = Number.parseInt(bruto, 10);
  if (Number.isNaN(parseado)) {
    return null;
  }
  return clampHorizonte(parseado, minimo, maximo);
}
